export function getPartialSelectInsuranceTrackingParams(productId, groups) {
    const insuranceProducts = groups.flatMap(group => group.products);
    const insuranceProduct = insuranceProducts.reduce((previousProduct, currentProduct) => {
        return previousProduct.id === productId ? previousProduct : currentProduct;
    }, insuranceProducts[0]);
    const insuranceGroup = groups.reduce((previousGroup, currentGroup) => {
        return previousGroup.products.includes(insuranceProduct) ? previousGroup : currentGroup;
    }, groups[0]);
    return {
        index: insuranceGroup.products.indexOf(insuranceProduct) + 1,
        total_indices: insuranceGroup.products.length,
    };
}
//# sourceMappingURL=getPartialSelectInsuranceTrackingParams.js.map